import React from 'react';
import { Link } from 'react-router-dom';

// Types
import { WpBreadcrumbType } from './types';

// Components

// Styles
import './WpBreadcrumbItem.scss';

const WpBreadcrumbItem = ({ label, to, onClick }: WpBreadcrumbType) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  const baseClassName = 'WpBreadcrumbItem';

  if (to) {
    return (
      <Link className={`${baseClassName} ${baseClassName}--clickable`} to={to}>
        {label}
      </Link>
    );
  }

  return (
    <div onClick={handleClick} className={`${baseClassName} ${onClick ? `${baseClassName}--clickable` : ''}`}>
      {label}
    </div>
  );
};

export default WpBreadcrumbItem;
